"use client";
import React, { useEffect, useRef, useState } from "react";
import { Button, Empty } from "antd";
import Image from "next/image";
import { Link } from "@/navigation";
import { PlusCircleOutlined, LoadingOutlined } from "@ant-design/icons";
import type { Blog } from "@/lib/@types/api/blog";
import { getBlogList } from "@/lib/api/blog";
import moment from "moment/moment";
import { useTranslations } from "next-intl";

const EnterpriseNews = ({ locale }) => {
	const t = useTranslations();
	const [blogList, setBlogList] = useState<Blog.BlogListItem[]>([]);
	const [pageSize, setPageSize] = useState(1);
	const limit = 12;

	const fetchBlogList = async (
		Params: Blog.GetBlogListParams,
	): Promise<{ blogList: Blog.BlogListItem[]; blogCount: number }> => {
		try {
			const res = await getBlogList(Params);
			return { blogList: res.detail.blog_list, blogCount: res.detail.blog_filter_count };
		} catch (error) {
			console.error("Error fetching blog list:", error);
			return { blogList: [], blogCount: 0 }; // 如果发生错误，返回一个空数组
		}
	};

	useEffect(() => {
		fetchBlogList({
			lang_code: { lang_code: locale },
			page: pageSize,
			limit,
			blog_title: "",
		}).then((res) => {
			if (res) {
				setBlogList(res.blogList);
			}
		});
	}, []);

	return (
		<div className="container py-16 max-md:py-8">
			<div className="flex flex-col gap-[12px]">
				<div className="text-center text-[3rem] font-bold leading-normal text-[#212121] max-md:text-2xl">
					{t("resource.Enterprise News")}
				</div>
				<div className="flex flex-row items-center justify-end gap-[12px] max-md:flex-col">
					<div className="flex justify-end max-md:w-full">
						<Link
							className="flex cursor-pointer justify-end gap-[20px] text-[#212121] hover:text-[#0e6aed] max-md:gap-[8px]"
							href="/blog"
						>
							<span className="whitespace-nowrap text-[20px] max-md:text-[14px]">
								{t("resource.View More")}
							</span>
							<PlusCircleOutlined className="text-[26px] max-md:text-[18px]" />
						</Link>
					</div>
				</div>
			</div>
			<div className="mt-8 grid grid-cols-2 gap-[35px] max-md:grid-cols-1">
				{blogList?.length > 0 ? (
					blogList?.slice(0, 4).map((item: any, index: number) => {
						{
							return (
								<Link
									href={"/blog/" + item.blog_slug}
									className="enterprise-news-item flex cursor-pointer gap-6"
									key={index}
								>
									<div className="flex w-[100px] shrink-0 flex-col items-center justify-center border border-[#c1c1c1]">
										<div className="text-[12px] font-bold text-[#212121]">
											{moment(item.blog_upload_time).format("MMM YYYY")}
										</div>
										<div className="text-[35px] font-bold leading-normal text-[#212121]">
											{moment(item.blog_upload_time).format("DD")}
										</div>
									</div>
									<div>
										<h3 className="enterprise-news-item-text my-2 line-clamp-2 h-14 !text-xl font-bold text-black">
											{item.blog_title}
										</h3>
										<p className="my-2 line-clamp-2 text-xs font-normal text-[#677E6E] max-md:my-1 sm:text-sm">
											{item.blog_excerpt}
										</p>
									</div>
								</Link>
							);
						}
					})
				) : (
					<Empty />
				)}
			</div>
		</div>
	);
};

export default EnterpriseNews;
